import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-sblock-text',
  templateUrl: './text.component.html',
  styleUrls: ['./text.component.scss']
})
export class SblockTextComponent {
  titlesColor = '#932F29';
  secondaryColor = '#555';

  /** Shows skeleton placeholders while the parent is fetching data */
  @Input() loading = false;

  @Input() alignImageBlock = 'right';
  /** Media type of the block; the play button only shows for 'video' */
  @Input() type = 'video';
  alignTextBlock = 'left';

  /** Content comes from the parent; no placeholder/demo fallbacks.
   *  Rendered via innerHTML, so it may be plain text or rich HTML. */
  @Input() title = '';
  @Input() subtitleText = '';
  @Input() thumbnail = '';
  /** Optional section background image (e.g. the registrations CTA banner) */
  @Input() backgroundImage = '';
  /** Optional section background color (e.g. per-level background_color) */
  @Input() backgroundColor = '';
  /** Centered-banner variant: centers the content and shows the background
   *  image in full (contain). Used by the registrations CTA block. */
  @Input() centered = false;

  playButton = 'assets/images/lesson/play.svg';

  @Input() btn1Active = true;
  @Input() btn1Text = 'Comenzar ahora';
  @Input() btn1Link = '#';
  /** When true, btn1 emits (btn1Action) instead of navigating to btn1Link */
  @Input() btn1AsAction = false;

  @Input() btn2Active = true;
  @Input() btn2Text = 'Saber mas';
  @Input() btn2Link = '#';
  linkColor = '#6c5ce7';

  /** Emitted when the primary button is clicked while btn1AsAction is true */
  @Output() btn1Action = new EventEmitter<void>();
  /** Emitted when the secondary button is clicked (parent decides what to do) */
  @Output() btn2Action = new EventEmitter<void>();

  onBtn1Click(event: Event): void {
    if (this.btn1AsAction) {
      event.preventDefault();
      this.btn1Action.emit();
    }
  }

  onBtn2Click(event: Event): void {
    event.preventDefault();
    this.btn2Action.emit();
  }
}
